export interface Clinic {
  serial: Serial;
  name: Name;
  ceoName: Name;
  phone: Phone;
  email: Email;
  website?: Website;
  fax?: Fax;
  streetAddress: StreetAddress;
  additionalAddress?: AdditionalAddress;
  city: City;
  zip: Zip;
}

export interface DiagnosticCategoryDto {
  id: Id;
  name: Name;
}

export interface BusinessHourDto {
  id: Id;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  sunday: string;
}

export interface ClinicDetailDto {
  id: Id;
  name: Name;
  ceo: string;
  shortAddress: string;
  longAddress: string;
  phone: Phone;
  latitude: string;
  longitude: string;
  timeOffset: number;
  diagnosticCategories: DiagnosticCategoryDto[];
  businessHours: BusinessHourDto;
  web: string;
  fax: Fax;
}
export interface ClinicInfoDto {
  id: Id;
  identifier: Email;
  serial: Serial;
  name: Name;
  ceo: string;
  apt: string;
  streetAddress: StreetAddress;
  city: City;
  zipCode: Zip;
  phone: Phone;
  web: string;
  fax: Fax;
}

export function DetailDtoToDomain(dto: ClinicDetailDto): Clinic {
  return {
    name: dto.name,
    serial: '',
    ceoName: dto.ceo,
    phone: dto.phone,
    email: '',
    website: dto.web,
    fax: dto.fax,
    streetAddress: '',
    additionalAddress: '',
    city: '',
    zip: '',
  };
}

export function ClinicInfoDtoToDomain(dto: ClinicInfoDto): Clinic {
  return {
    serial: dto.serial,
    name: dto.name,
    ceoName: dto.ceo,
    phone: dto.phone,
    email: dto.identifier,
    website: dto.web,
    fax: dto.fax,
    streetAddress: dto.streetAddress,
    additionalAddress: dto.apt,
    city: dto.city,
    zip: dto.zipCode,
  };
}
